<template lang="pug">
  app-dialog(v-model="$_show" header="Новый документ базы знаний" :width="900" confirm-text="Сохранить" :confirm-disabled="!ready" @confirm="create")

    div(v-if="rootCategory && rootCategory.alias === 'common'")
      v-row
        .col-6
          v-menu
            template(v-slot:activator="{ on }")
              v-text-field(v-model="cCategory" label="Раздел" v-on="on" outlined light color="blue" readonly)
            v-card
              v-treeview(dense activatable open-all return-object item-key="id" item-text="title" :active.sync="selectedCategory" :items="knowledgeCategory")
        .col-6
          app-text-field(v-model="newDoc.decree" label="Вид документа")
      v-row
        .col-6
          app-text-field(v-model="newDoc.judgeName" label="Автор")
        .col-6
          app-text-field(v-model="newDoc.number" label="Входящий номер")
      
      app-text-field(v-model="newDoc.clause" label="Название")
      v-textarea(v-model="newDoc.note" label="Краткое содержание документа")

    div(v-else)
      v-row
        .col-6
          v-menu
            template(v-slot:activator="{ on }")
              v-text-field(v-model="cCategory" label="Раздел" v-on="on" outlined light color="blue" readonly)
            v-card
              v-treeview(dense activatable open-all return-object item-key="id" item-text="title" :active.sync="selectedCategory" :items="knowledgeCategory")
        .col-6
          app-select(v-model="newDoc.type" :items="typeList" label="Тип делопроизводства")
      v-row
        .col-6
          app-text-field(v-model="newDoc.year" label="Год")
        .col-6
          app-text-field(v-model="newDoc.clause" label="Статья")
      v-row
        .col-6
          app-text-field(v-model="newDoc.judgeName" label="Судья")
        .col-6
          app-text-field(v-model="newDoc.sides" label="Стороны")
      v-row
        .col-6
          app-text-field(v-model="newDoc.number" label="Номер")
        .col-6
          app-text-field(v-model="newDoc.colleg" label="Состав коллегии")
      v-row
        .col-6
          app-text-field(v-model="newDoc.decree" label="Принятое решение")
        .col-6
          app-select(v-model="newDoc.decreeState" :items="decreeStateList" label="Решение")

    v-row
      .col-6
        app-date-picker(v-model="newDoc.date" view-format="DD.MM.YYYY")
      .col-6
        app-file-input(v-model="newDoc.fileExt" :formats="[]" :maxSize="maxFileSize")

</template>

<script>
import { mapGetters, mapState } from 'vuex'
import { AppDialogToggable } from "@/components"
import Uploader from '@/common/Uploader'

let baseDoc = {knowledgeCategory:null, year: null, clause: null, judgeName: null, sides: null, number: null, date: null, decree: null, decreeState: null, type: null, colleg:null, note:null, fileExt: null }

export default {
  mixins: [AppDialogToggable, Uploader],

  computed: {
    ...mapState('knowledgeBase', ['knowledgeCategory','decreeStateList','typeList']),
    ...mapGetters('knowledgeBase', ['gKnowledgeCategory', 'gKnowledgeDocs','gDecreeStateList','gTypeList']),

    choosenCategory(){
      if (this.newDoc.knowledgeCategory) return this.newDoc.knowledgeCategory.title
      return ''
    },

    cCategory() {
      if (this.selectedCategory[0]) return this.selectedCategory[0].title
      return ''
    },

    rootCategory(){
      if (this.selectedCategory[0]) {
        return this.findRootCatSelected(this.selectedCategory[0])
      }
      return null
    },

    ready () {
      let docReady = false
      if (this.rootCategory && this.rootCategory.alias === 'common') {
        docReady = !!this.selectedCategory && !!this.selectedCategory[0] && !!this.newDoc.clause && !!this.newDoc.judgeName && !!this.newDoc.number && !!this.newDoc.decree && !!this.newDoc.note && !!this.newDoc.date //&& !!this.newDoc.fileExt
      } else if (this.selectedCategory[0] && (this.selectedCategory[0].alias === 'appeal' || this.selectedCategory[0].alias === 'cassation')) {
        docReady = !!this.newDoc.type && !!this.newDoc.date && !!this.newDoc.fileExt
      } else {
        docReady = !!this.selectedCategory && !!this.selectedCategory[0] && !!this.newDoc.year && (/^\d{1,4}$/i).test(this.newDoc.year) && !!this.newDoc.clause && !!this.newDoc.judgeName && !!this.newDoc.sides && !!this.newDoc.number && !!this.newDoc.decree && !!this.newDoc.decreeState && !!this.newDoc.type && !!this.newDoc.colleg && !!this.newDoc.date //&& !!this.newDoc.fileExt
      }
      if (this.newDoc.fileExt && this.newDoc.fileExt.size > this.maxFileSize) docReady = false
      return docReady
    },
  },

  methods: {
    //...mapActions('fileStore', ['createDocument', 'createTemplate']),

    $_beforeShow () {
      this.newDoc = {knowledgeCategory:null, year: null, clause: null, judgeName: null, sides: null, number: null, date: null, decree: null, decreeState: null, type: null, colleg:null, note:null, fileExt: null };
      this.selectedCategory = [];
    },

    findRootCatSelected(item){
      return this.findRootCatSelectedRec(this.knowledgeCategory,item)
    },

    findRootCatSelectedRec(arr,item){
      let rootCat = arr.filter(i => {return i.id == item.id})[0]
      if (!rootCat){
        for (let itm of arr) {
          let cc = this.findRootCatSelectedRec(itm.children,item)
          if (cc) {
            rootCat = itm
            break
          }
        }
      }
      return rootCat
    },

    create () {
      this.newDoc.knowledgeCategory = this.selectedCategory[0];

      if (this.newDoc.fileExt != null) {
        this.$_uploadFile(this.newDoc.fileExt).then(name => {
            this.saveAdd(name)
        })
      } else this.saveAdd(null)
    },

    saveAdd(filename){
      let o = {};
      if (this.rootCategory && this.rootCategory.alias === 'common') {
        o = {
          knowledgeCategory:this.newDoc.knowledgeCategory,
          clause:this.newDoc.clause,
          judgeName:this.newDoc.judgeName,
          number:this.newDoc.number,
          date:this.newDoc.date+' 00:00',
          decree:this.newDoc.decree,
          year:null,
          sides:null,
          decreeState:null,
          type:null,
          colleg:null,
          note:this.newDoc.note,
          fileExt:filename
        };
      } else {
        o = {
          knowledgeCategory:this.newDoc.knowledgeCategory,
          type:this.newDoc.type.value,
          year:this.newDoc.year,
          clause:this.newDoc.clause,
          judgeName:this.newDoc.judgeName,
          sides:this.newDoc.sides,
          number:this.newDoc.number,
          date:this.newDoc.date+' 00:00',
          colleg:this.newDoc.colleg,
          decree:this.newDoc.decree,
          decreeState: this.newDoc.decreeState ? this.newDoc.decreeState.value : null,
          note:this.newDoc.note,
          fileExt:filename
        };
      }
      let data = {cat:this.selectedCategory[0].id,doc:o}
      this.$store.dispatch('knowledgeBase/addKnowledgeDoc',data)
    }

      

  },

  data () {
    return {
      maxFileSize:50240000,
      selectedCategory:[],
      newDoc: { ...baseDoc }
    }
  },
}
</script>

<style lang="scss" scoped>
  .v-menu.v-menu--inline{display:none;}
  .col-6{padding:0 12px;}
</style>